import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';

interface ObservationModalProps {
  isOpen: boolean;
  toggle: () => void;
  observation: string | null;
}

export default function ObservationModal({
  isOpen,
  toggle,
  observation,
}: ObservationModalProps) {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_AUTHORIZATION);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Row className="pb-4">
        <Col xs={12} className="text-center">
          <Icon name="information" size="50px" color="primary" />
          <h1 className="text-dark fs-22 mt-3">
            {t('observationModal.title')}
          </h1>
        </Col>
      </Row>
      <p
        className="text-center fs-16"
        style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
      >
        {observation || t('observationModal.empty')}
      </p>
      <Row className="pt-4">
        <Col xs={12} sm={{ size: 6, offset: 3 }}>
          <Button text={t('table.close')} fullwidth onClick={toggle} />
        </Col>
      </Row>
    </Modal>
  );
}
